import { ApiClientError } from '../../lib/api';

/**
 * The Secrets API answers a bad signup with a message per field. Surfacing them
 * against the right input is the whole reason our backend translates them, so
 * the unwrapping lives in one place.
 */
export type FieldErrors = Record<string, string[]>;

export function fieldErrorsFrom(err: unknown): FieldErrors {
  return err instanceof ApiClientError && err.details ? err.details : {};
}

export function messageFrom(err: unknown, fallback: string): string {
  return err instanceof ApiClientError ? err.message : fallback;
}
